module.exports = __webpack_public_path__ + "static/media/file-check.cb0dc7ee.svg";